import type { FeatureGroup } from '../../../types';
import { PAYMENTS_FEATURE_GROUP } from '../group';

export const PAYMENTS_SETTINGS_FEATURE_GROUP: FeatureGroup = {
  guid: 'b1f0c3a4-5d62-4e78-9a01-3c7d5e9f05ff',
  name: 'payments_settings',
  description: 'Payments settings — the organization account details, categories and the receipt email',
  product: 'payments',
  parentGuid: PAYMENTS_FEATURE_GROUP.guid,
};
